import { compose } from 'redux';

import type { RoutingState } from '../routingStore';

export const selectRoutingDomain = (state: RoutingState) => state.newRouting;

export const selectSpreadsheetImportResultAddressesesWebData = compose((state) => state.spreadsheetImportResultAddressesWebData, selectRoutingDomain);

export const selectRoutingWebData = compose((state) => state.routingWebData, selectRoutingDomain);

export const selectEditRouteWebData = compose((state) => state.editRouteWebData, selectRoutingDomain);

export const selectDeleteRoutesWebData = compose((state) => state.deleteRoutesWebData, selectRoutingDomain);

export const selectParsedSpreadsheetWebData = compose((state) => state.parsedSpreadsheet, selectRoutingDomain);
